export const init = () => {
	document.addEventListener("click", (event) => {
		if (event.target && event.target.matches(".modal__button-close")) {
			const element = document.getElementById("login-page")
			if (element) {
				element.classList.add("login-unselected")
				element.classList.remove("login-selected")
			}
		}

		if (event.target && event.target.matches(".modal__button-open")) {
			const element = document.getElementById("login-page")
			if (element) {
				element.classList.add("login-selected")
				element.classList.remove("login-unselected")
			}
		}
	})
}
